<template>
  <div class="wrap-footer no-print">
    <div v-if="$route.name !== 'LocationSlug' && $route.name !== 'ReservationsSlug'">
      <hr class="space xs border-top" />
      <div class="footer-content">
        <ul class="sidebar-menu">
          <li class="sidebar-menu-item">
            <a
              href="#"
              @click.prevent="openSidebarLink('home')"
              v-scroll-to="'#features'"
              >FEATURES & BENEFITS</a
            >
          </li>

          <li class="sidebar-menu-item">
            <a
              href="#"
              @click.prevent="openSidebarLink('home')"
              v-scroll-to="'#contact_us'"
              >CONTACT US</a
            >
          </li>
          <li class="sidebar-menu-item">
            <a href="" @click.prevent="openSidebarLink('pages/terms')"
              >TERMS OF USE</a
            >
          </li>
          <li class="sidebar-menu-item">
            <a href="" @click.prevent="openSidebarLink('pages/privacy')"
              >PRIVACY</a
            >
          </li>
        </ul>
        <div class="social-group">
          <a target="_blank" href="https://www.facebook.com/opencabana/"
            ><i class="fa fa-facebook"></i
          ></a>
          <a target="_blank" href="https://www.twitter.com/opencabana/"
            ><i class="fa fa-twitter"></i
          ></a>
          <a target="_blank" href="https://www.instagram.com/opencabana/"
            ><i class="fa fa-instagram"></i
          ></a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UC4guebgvIj1sTBwV4Da3tjg/"
            ><i class="fa fa-youtube"></i
          ></a>
        </div>
      </div>
      <hr class="space xs" />
    </div>

    <p>&copy; <router-link to="/">OpenCabana</router-link>, {{ date }}.</p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Footer",
  methods: {
    openSidebarLink(page) {
      if (page === "home") {
        this.$router.push("/home");
      } else {
        this.$router.push("/" + page);
      }
    },
  },
  data() {
    return {
      date: moment(new Date()).format("YYYY"),
    };
  },
};
</script>

<style lang="scss" scoped>
.wrap-footer {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  width: 100%;
  padding: 0 100px;
  text-align: center;
  @media only screen and (max-width: 880px) {
    padding: 0 30px;
  }
  hr {
    margin: 0 0 10px 0;
  }
  .footer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    @media only screen and (max-width: 680px) {
      flex-direction: column;
    }
    .sidebar-menu {
      display: flex;
      list-style-type: none;
      padding: unset;
      margin: 0;
      @media only screen and (max-width: 680px) {
        width: 400px;
        justify-content: space-between;
      }
      @media only screen and (max-width: 520px) {
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
      @media only screen and (max-width: 410px) {
        width: 100%;
      }
      .sidebar-menu-item {
        margin: 0 25px 0 0;
        @media only screen and (max-width: 680px) {
          margin: 0;
        }
        @media only screen and (max-width: 520px) {
          margin-top: 10px;
          width: 135px;
          text-align: center;
        }
        @media only screen and (max-width: 410px) {
          width: 100%;
        }
        a {
          text-decoration: none;
          color: #777;
        }
      }
    }
    .social-group {
      @media only screen and (max-width: 680px) {
        margin-top: 20px;
        width: 150px;
        display: flex;
        justify-content: space-between;
      }
      a {
        margin-left: 20px;
         @media only screen and (max-width: 680px) {
        margin: 0;
      }
        i {
          font-size: 22px;
          color: #777;
        }
      }
    }
  }
  .border-top{
    display: none;
    @media only screen and (max-width: 520px) {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?9d143ce8